import { render, staticRenderFns } from "./ModalAtividades.vue?vue&type=template&id=2f21c096&scoped=true&"
import script from "./ModalAtividades.vue?vue&type=script&lang=js&"
export * from "./ModalAtividades.vue?vue&type=script&lang=js&"
import style0 from "./ModalAtividades.vue?vue&type=style&index=0&id=2f21c096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f21c096",
  null
  
)

export default component.exports